import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import type { ImageColumnProps } from '@modules/page-builder/types';
import { DUO_COLUMN_WIDTH_MD } from '@modules/page-builder/config/column-constants';
import DetailSingleImageShell from '../detail-single-image-shell/DetailSingleImageShell';
import * as S from './DuoImageModule.style';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import ImageWithPaintPicker from '../../common/image-with-paint-picker/ImageWithPaintPicker';
import { ImageModuleExtraSpacing } from '@modules/page-builder/component/detail/detail-modules/DetailModules.style';

interface DuoImageModuleProps {
    columns: ImageColumnProps[];
}

const DuoImageModule = ({ columns }: DuoImageModuleProps) => {
    const { mobile } = useAppDisplayModeContext();
    const isDuoPortrait =
        columns.length > 0 && columns.every((c) => c.dimension?.isPortrait);

    const { css } = useStyles({
        isDuoPortrait,
    });

    return (
        <div
            className={css(S.DuoImageModuleContainer, ImageModuleExtraSpacing)}
        >
            {columns.map((column) => {
                const isSmall = column.dimension.width < DUO_COLUMN_WIDTH_MD;

                if (mobile && !column.imageUrl) {
                    return null;
                }

                return (
                    <div
                        key={column.id}
                        className={css(
                            S.DuoImageContainerImage(
                                isSmall,
                                column.dimension.isPortrait,
                            ),
                        )}
                    >
                        {column?.imageUrl && (
                            <DetailSingleImageShell
                                caption={column.caption}
                                dimension={column.dimension}
                                libraryImage={column?.libraryImage}
                                tags={column.tags}
                                uniqueApprovedTags={column.uniqueApprovedTags}
                                imageURL={column.imageUrl}
                                columnId={column.id}
                                moduleType="DuoImageModule"
                            >
                                <ImageWithPaintPicker
                                    src={column.imageUrl}
                                    width={column.dimension.width}
                                    height={column.dimension.height}
                                    layout={'fill'}
                                    objectFit={'cover'}
                                    sizes={
                                        isSmall
                                            ? getImagesSizes(800)
                                            : getImagesSizes(1050)
                                    }
                                    alt={
                                        column.caption ||
                                        column?.libraryImage?.Title ||
                                        ''
                                    }
                                    className="overflow-hidden md:rounded-2"
                                />
                            </DetailSingleImageShell>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default DuoImageModule;
